import { createApp, defineComponent, h, ref } from 'vue'
import AppConfirmDialog from '@/components/ui/AppConfirmDialog.vue'

/**
 * Muestra un diálogo de confirmación y retorna Promise<boolean>.
 *
 * Uso:
 *   const ok = await useConfirm().confirm({ title: '¿Eliminar?', icon: 'error' })
 *   if (!ok) return
 */
export function useConfirm() {
  function confirm(options = {}) {
    return new Promise(resolve => {
      const container = document.createElement('div')
      document.body.appendChild(container)

      const app = createApp(
        defineComponent({
          setup() {
            const visible = ref(true)

            function onResolve(value) {
              visible.value = false
              setTimeout(() => {
                app.unmount()
                container.remove()
              }, 200)
              resolve(value)
            }

            return () =>
              h(AppConfirmDialog, {
                visible: visible.value,
                title: options.title ?? '',
                text: options.text ?? '',
                icon: options.icon ?? 'warning',
                showCancel: options.showCancel ?? true,
                confirmText: options.confirmText ?? 'Confirmar',
                cancelText: options.cancelText ?? 'Cancelar',
                onResolve,
              })
          },
        })
      )

      app.mount(container)
    })
  }

  return { confirm }
}
